import {
  TextField,
  Button,
  Stack,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import ForgotPassword from "./partials";
import { useState } from "react";

const Login = ({ showPassword }: { showPassword: boolean }) => {
  const form = useFormContext();
  const [isOpenForgotPassword, setIsOpenForgotPassword] = useState(false);

  const handleConnect = (scheme: string) => {
    window.open(
      `https://wrd-ngdi-api-wrd-prod.eu.mike-cloud.com/api/auth/Login/${scheme}?redirectUri=${
        window.location.origin + window.location.pathname
      }?`,
      "_self",
    );
  };

  return (
    <Stack spacing={2.5}>
      <Stack direction="row" spacing={2}>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => handleConnect("Google")}
        >
          <Stack gap={0.5} direction="row" alignItems="center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
            >
              <path
                d="M18.3 9.5175C18.3 14.8238 14.6663 18.6 9.3 18.6C4.155 18.6 0 14.445 0 9.3C0 4.155 4.155 0 9.3 0C11.805 0 13.9125 0.91875 15.5363 2.43375L13.005 4.8675C9.69375 1.6725 3.53625 4.0725 3.53625 9.3C3.53625 12.5438 6.1275 15.1725 9.3 15.1725C12.9825 15.1725 14.3625 12.5325 14.58 11.1638H9.3V7.965H18.1537C18.24 8.44125 18.3 8.89875 18.3 9.5175Z"
                fill="black"
              />
            </svg>
            <Typography>Connect with Google</Typography>
          </Stack>
        </Button>
        {/* <Button
          fullWidth
          variant="outlined"
          onClick={() => handleConnect("Microsoft")}
        >
          <Stack gap={0.5} direction="row" alignItems="center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
            >
              <path
                d="M0 0H8.0475V8.0475H0V0ZM8.7525 0H16.8V8.0475H8.7525V0ZM0 8.7525H8.0475V16.8H0V8.7525ZM8.7525 8.7525H16.8V16.8H8.7525V8.7525Z"
                fill="black"
              />
            </svg>
            <Typography>Connect with Microsoft</Typography>
          </Stack>
        </Button> */}
      </Stack>

      <Stack direction="row" alignItems="center" spacing={2}>
        <Divider sx={{ flex: 1 }} />
        <Typography variant="body2">Or</Typography>
        <Divider sx={{ flex: 1 }} />
      </Stack>

      <Controller
        name="email"
        render={({ field }) => (
          <TextField
            label="Email"
            placeholder="email@email.com"
            fullWidth
            {...field}
            error={Boolean(form.formState.errors?.["email"])}
            helperText={`${form.formState.errors?.["email"]?.message ?? ""}`}
          />
        )}
        control={form.control}
      />

      <Controller
        name="password"
        render={({ field }) => (
          <TextField
            label="Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            {...field}
            error={Boolean(form.formState.errors?.["password"])}
            helperText={`${form.formState.errors?.["password"]?.message ?? ""}`}
          />
        )}
        control={form.control}
      />

      <Box>
        <Button
          variant="text"
          size="small"
          onClick={() => setIsOpenForgotPassword(true)}
        >
          <Typography
            color="#515167"
            sx={{ cursor: "pointer", width: "fit-content" }}
          >
            Forgot password?
          </Typography>
        </Button>
      </Box>
      {isOpenForgotPassword && (
        <ForgotPassword
          open={isOpenForgotPassword}
          setOpen={setIsOpenForgotPassword}
        />
      )}
    </Stack>
  );
};

export default Login;
